import { useLanguage } from "@/i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div className="relative overflow-hidden border-y border-ebony/10 bg-bone py-6 md:py-8" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-24 pr-24">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-24 whitespace-nowrap">
            <span className={`font-serif text-2xl md:text-4xl tracking-tight ${i % 2 === 0 ? "text-ebony" : "italic text-terracotta"}`}>
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-ochre" />
          </span>
        ))}
      </div>
    </div>
  );
}
